// https://discourse.threejs.org/t/how-to-converting-world-coordinates-to-2d-mouse-coordinates-in-threejs/2251

import { mapper } from './mapper'

export function toScreenPosition(position = new Vector3(), camera, width, height) {
  const p = position.clone()
  camera.updateMatrixWorld(true)
  const vector = p.project(camera)

  // vector.x = (vector.x + 1) * (width * .5)
  // vector.y = -(vector.y - 1) * (height * .5)

  vector.x = mapper(vector.x, -1, 1, 0, width)
  vector.y = mapper(vector.y, 1, -1, 0, height)
  vector.z = 0

  return vector
}